import { render } from "./ProductModal.vue?vue&type=template&id=2c04cb92"
import script from "./ProductModal.vue?vue&type=script&lang=ts"
export * from "./ProductModal.vue?vue&type=script&lang=ts"

import "./ProductModal.vue?vue&type=style&index=0&id=2c04cb92&lang=scss"
script.render = render

export default script